export default __webpack_public_path__ + "static/media/delete.9e5f39fa.svg";